import styled from 'styled-components';
import { Text } from "@chakra-ui/core";

export const Container = styled.div`
    display: inline-block;
    position: relative;
    margin-bottom: 20px;
`;

export const Label = styled(Text)`
    color: #01509C;
    position: absolute;
    background-color: white;
    padding: 0 5px;
    font-size: 10px;
    z-index: 99;
    top: -8px;
    left: 8px;
    white-space: nowrap;
`;